import React, { useEffect, useState } from 'react';

import './App.css';

import up from './assets/icons/up.png';


import AboutMe from './PortfolioContainer/AboutMe/AboutMe';
import Experience from './PortfolioContainer/Experience/Experience.js';
import Profile from './PortfolioContainer/Home/Profile';
import Project from './PortfolioContainer/Projects/Projects';
import School from './PortfolioContainer/School/School';
import ContactTestimonials from './PortfolioContainer/ContactTestimonials/ContactTestimonials.js';

function App() {

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 200) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    })
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="App">
      <div className="scroll-button">
        {showButton && (
          <button onClick={handleClick} style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 3 }}>
            <img src={ up } alt="top" />
          </button>
        )}
      </div>
      <Profile/>
      <AboutMe/>
      <School/>
      <Project/>
      <Experience/>
      <ContactTestimonials />
    </div>
  );
}

export default App;
